import React, { Component } from 'react'

export default class TabTitle extends Component {
  render() {
    return (
      <li role="presentation" className={this.props.tab.id === this.props.selectedTab ? "active" : ""}>
        <a data-toggle="tab" href="" id={this.props.tab.id} role="tab" onClick={this.props.selectTab}>{this.props.tab.name}</a>
      </li>
    )
  }
}
